import { Link } from 'react-router-dom';
import { coreAdvantages } from '@/mocks/home';

function CoreAdvantages() {
  return (
    <section className="relative py-20 md:py-28 px-4 md:px-8 lg:px-12 bg-background-100 overflow-hidden">
      {/* Subtle decorative gradient */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-primary-500/[0.015] blur-[150px]" />
      </div>

      <div className="max-w-7xl mx-auto relative">
        {/* Top row: text left, image right */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center mb-20">
          {/* Left text */}
          <div>
            <span className="inline-block px-4 py-1.5 mb-5 text-xs font-medium text-primary-600 bg-primary-50 rounded-full">
              核心技术优势
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-5 leading-tight tracking-tight">
              自研 ASR + MT + LLM
              <br />
              <span className="text-primary-600">全链路 AI 引擎</span>
            </h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-8 max-w-lg">
              新译科技深耕 AI 翻译领域多年，自主研发语音识别、机器翻译、大语言模型三大核心技术，实现从语音采集到智能翻译的全链路闭环，为全球用户提供高效、精准、安全的翻译服务。
            </p>
            <div className="flex flex-col sm:flex-row gap-3.5">
              <Link
                to="/support/downloads"
                className="group inline-flex items-center justify-center gap-2 px-6 py-3.5 bg-primary-500 text-white text-sm font-semibold rounded-full hover:bg-primary-400 transition-all duration-300 whitespace-nowrap cursor-pointer hover:shadow-[0_4px_20px_rgba(0,0,0,0.1)]"
              >
                <i className="ri-file-download-line"></i>
                下载技术白皮书
                <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform inline-block"></i>
              </Link>
              <a
                href="#consultation"
                className="inline-flex items-center justify-center gap-2 px-6 py-3.5 border border-primary-200 text-primary-600 text-sm font-semibold rounded-full hover:bg-primary-50 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                预约技术演示
              </a>
            </div>
          </div>

          {/* Right image with decorative frame */}
          <div className="relative">
            <div className="absolute -inset-3 bg-primary-500/[0.04] rounded-3xl" />
            <div className="absolute -inset-1.5 border border-primary-200/40 rounded-2xl" />
            <img
              src="/images/home/ai-engine-architecture.jpg"
              alt="AI引擎技术架构"
              className="relative z-10 w-full rounded-2xl"
            />
          </div>
        </div>

        {/* Bottom row: 5 advantage cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {coreAdvantages.map((adv, idx) => (
            <div
              key={idx}
              className="group bg-white rounded-2xl p-5 md:p-6 border border-background-200 hover:border-primary-200/70 transition-all duration-400 hover:-translate-y-1 hover:shadow-[0_8px_30px_-8px_rgba(0,0,0,0.05)]"
            >
              {/* Icon */}
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 mb-4 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                <i className={`${adv.icon} text-lg`}></i>
              </div>
              {/* Title */}
              <h4 className="text-sm font-bold text-foreground-900 mb-2">{adv.title}</h4>
              {/* Description */}
              <p className="text-xs text-foreground-500 leading-relaxed">{adv.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CoreAdvantages;